import(/* webpackMode: "eager", webpackExports: ["ContentLink"] */ "/app/components/Link/ContentLink/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/containers/InsuranceHandbookPage/index.tsx");
